import React from "react";
import PropTypes from 'prop-types';

import StreamEvent from "./StreamEvent";
import LoadEventsButton from './LoadEventsButton';
import {parseDate} from '../../../../assets/util';

const mapEventsToStreamEvents = (events, attributes, hasPrev, currentParticipant, thread) => {
    let lastAuthor = null;
    let lastDate   = null;
    const firstEvent = events.first();
    const isIpcRequest = thread.threadType && thread.threadType.code === 'ipc-request';
    const hasAttributes = attributes.filter((a) => a.value).length > 0;

    // firstId stays on workflow event (so it gets isFirst=true and is hidden by StreamEvent)
    const firstId = firstEvent.id;

    // firstContentId points to first message event for ipc-request without attributes,
    // so that message event gets rendered as attribute table instead of plain chat bubble
    let firstContentId = firstId;
    if (isIpcRequest && firstEvent.type === 'workflow' && !hasAttributes && events.size > 1) {
        const secondEvent = events.get(1);
        if (secondEvent && secondEvent.type === 'message') {
            firstContentId = secondEvent.id;
        }
    }

    return events.map((event) => {
        /**
         * Date of current event.
         */
        const dateValue = parseDate(event.createdAt);
        const date = `${dateValue.getUTCFullYear()}/${dateValue.getUTCMonth()}/${dateValue.getUTCDate()}`;

        /**
         * For ipc-request, the first content event (first message) must always show
         * date and author, because the preceding workflow event (which is hidden) has
         * already consumed the "changed" state in this map loop.
         */
        const forceAuthorDate = event.id === firstContentId && event.id !== firstId && true !== hasPrev;

        /**
         * Date is changed if events date is not equal lastDate.
         */
        const dateChanged = forceAuthorDate || lastDate !== date;

        /**
         * Author is changed if events author is not equal last author.
         */
        const authorChanged = forceAuthorDate || event.author != lastAuthor;

        /**
         * Event is self if it's authored by currentParticipant.
         */
        const self = event.author === currentParticipant;

        /**
         * Event is first if this is the fist event in list, and there is no
         * previsous event according to api.
         */
        const isFirst = event.id === firstId && true !== hasPrev;

        /**
         * isFirstContent is true for the first visible content event.
         * For ipc-request this is the first message event (workflow event is hidden).
         */
        const isFirstContent = event.id === firstContentId && true !== hasPrev;

        /**
         * Stream event object. Represents event that is usable for stream.
         */
        const streamEvent = {
            event,
            self,
            authorChanged,
            dateChanged,
            isFirst,
            isFirstContent,
            thread,
            attributes: (isFirst || isFirstContent) ? attributes : null
        };

        lastAuthor = event.author;
        lastDate = date;

        return streamEvent;
    });
};

const EventStream = ({events, attributes, hasPrev, loadPrev, thread, currentParticipant}) => (
    <div className='event-list'>
        {true === hasPrev ? <LoadEventsButton onClick={loadPrev}/> : null}
        {mapEventsToStreamEvents(events, attributes, hasPrev, currentParticipant, thread)
            .map((streamEvent) => (
                <StreamEvent key={streamEvent.event.id} {...streamEvent}/>
            ))
        }
    </div>
);

EventStream.propTypes = {
    events: PropTypes.any.isRequired,
    attributes: PropTypes.any.isRequired,
    hasPrev: PropTypes.bool.isRequired,
    currentParticipant: PropTypes.number.isRequired
};

export default EventStream;
